<div class="container d-flex flex-column" style="margin-top: 28px;">
    <mat-divider></mat-divider>
    <footer style="font-size: 12px;">
        &copy; Todos os direitos reservados a <a href="https://empreenderdinheiro.com.br/"> Empreender Dinheiro</a>
    </footer>
</div>